import {
  LogProvider
} from 'providers';

export class Logger {

  static info(
    component = '',
    method = '',
    message = ''
  ) {

    LogProvider.info(component, method, message)
      .catch(e => console.log(e));
  }

  static error(
    component = '',
    method = '',
    ex
  ) {

    LogProvider.error(component, method, ex)
      .catch(e => console.log(e));
  }
}